import Styles from './index.module.scss'
import lion from '../imgs/lion.png'
import smallStar from '../imgs/smallstar@2x.png'
import bigStar from '../imgs/bigstar@2x.png'
import btnBg from '../imgs/btnbg@2x.png'
import shareBtn from '../imgs/sharebtn@2x.png'
import newYearImg33 from '../imgs/33@2x.png'
import newYearImg44 from '../imgs/44@2x.png'
import giftIconImg from '../imgs/55@2x.png'
import React, {useEffect, useMemo, useRef, useState} from "react";
import SyntheticConfirmModal from "../components/syntheticConfirmModal";
import ShareModal from "../components/shareModal";
import OpenAppFooter from "../components/openAppFooter";
import Service from "../service";
import Library from "../../../../library";
import NFTModal from "../../womenDay/components/NFTModal";
import GetFragmentsModal from "../components/getFragmentsModal";
import {Toast} from "antd-mobile";
import RulesModal from "../components/rulesModal";
import { is } from 'immutable'
/**
 * @description 邀新得碎片，合成藏品
 * @return {/front/activities/fragmentsSynthetic}
 */
const { JsBridge, Platform } = Library;
const isMiniprogram = Platform.check.isMiniprogram()

const Home = (props) => {
  const {clientId, openId, inviteId} = Library.Util.url.paramsToObj();
  const pageDom = useRef(null);
  const [userInfo, setUserInfo] = useState({});
  const [userInfoVerify, setUserInfoVerify] = useState({})
  const [data, setData] = useState({});
  const [popVisable, setPopVisable] = useState(false);

  // 提示信息
  const tipsMessage = useMemo(() => {
    let msg = undefined;
    const { systemTime, startTime, endTime } = data;
    const currentT = new Date(systemTime?.replace(/-/g, "/")).getTime();
    const startT = new Date(startTime?.replace(/-/g, "/")).getTime();
    const endT = new Date(endTime?.replace(/-/g, "/")).getTime();
    if (!startTime || !endTime) {
      msg = "接口异常";
    } else if (currentT < startT) {
      msg = "活动未开始";
    } else if (currentT > endT) {
      msg = "活动已结束";
    }
    return msg;
  }, [data]);

  useEffect(() => {
    (()=>{
      getData(true, true);
      onDidFocus();
    })()

  }, []);
  const onDidFocus = () => {
    window.JsBridge.addListener().then(() => {
      getData(true)
      onDidFocus();
    });
  }
  const getData = async (loading = false, isFirst = false ) => {
    // 假数据用于展示页面全貌 - 先设置，确保页面能立即显示
    const mockData = {
      list: [],
      drawCount: 0,
      isFirst: 0,
      rareSynthesized: 0,
      rareRemaining: 0,
      systemTime: new Date().toISOString().split('T')[0],
      startTime: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
      endTime: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    };
    setData(mockData);
    console.log('使用假数据展示页面全貌:', mockData);
    
    const userInfoRes = await JsBridge.getDetailCurrentUserInfo()
    if(!userInfoRes.isLogin && !isMiniprogram) {
      JsBridge.goLogin().then();
      return; // 即使返回，假数据也已经设置了
    }
    setUserInfoVerify(userInfoRes)
    const userInfo = await JsBridge.getCurrentUserInfo();
    setUserInfo(userInfo)
    console.log(userInfo)
    
    // 尝试获取真实数据（如果接口可用，会在接口成功后覆盖假数据）
    try {
      const result = await Service.getInitData(
        {
          clientId: isMiniprogram ? clientId : userInfo?.clientId,
          miniOpenId: isMiniprogram && openId && openId !== 'undefined' && openId !== 'null' ? openId : null,
          inviteId: isMiniprogram && inviteId && inviteId !== 'undefined' && inviteId !== 'null' ? inviteId : null,
          eventType:1
        },
        loading,
      );
      if (result?.data) {
        // 只有当接口返回的数据中有非空的列表时，才使用真实数据；否则保留假数据
        if (result.data.list && Array.isArray(result.data.list) && result.data.list.length > 0) {
          console.log('使用接口返回的真实数据:', result.data);
          setData(result.data)
          if(result.data.isFirst === 1 && isMiniprogram && isFirst) {
            handleGetFragments()
          }
        } else {
          console.log('接口返回数据但列表为空，继续使用假数据');
        }
      }
    } catch (error) {
      console.log('接口调用失败，继续使用假数据:', error);
    }
  }
  const handleSynthetic = () => {
    // if (isMiniprogram) {
    //   setPopVisable(true)
    //   return
    // }
    if (tipsMessage) {
      Toast.show(tipsMessage);
      return;
    }
    // if (!userInfoVerify?.ID) {
    //   return Toast.show('请先实名认证')
    // }
    const query = [
      clientId && `clientId=${encodeURIComponent(clientId)}`,
      openId && `openId=${encodeURIComponent(openId)}`,
      `imageList=${encodeURIComponent(JSON.stringify(imageList))}`,
      `blessingList=${encodeURIComponent(JSON.stringify(blessingList))}`,
    ].filter(Boolean).join('&')
    const uri = `/front/activities/fragmentsSyntheticMa/syntheticPage${query ? `?${query}` : ''}`
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push("CustomWeb", { uri: `${window.location.origin}${uri}` })
    } else {
      props.history.push(uri)
    }
  }
  const handleShare = () => {
    if (tipsMessage) {
      Toast.show(tipsMessage);
      return;
    }
    const ModalInstance = NFTModal.show({
      content: <ShareModal
        onClose={() => ModalInstance?.close()}
      />,
      getContainer: pageDom.current,
      closeOnMaskClick: true,
    });
  }
  const handleGetFragments = async () => {
    const result = await Service.getFragmentsService(
      {
        clientId,
        miniOpenId: openId,
        eventType:1
      },
      true,
    );
    if (result?.data?.parts) {
      const ModalInstance = NFTModal.show({
        content: <GetFragmentsModal
          onClose={() => ModalInstance?.close()}
          successCallBack={() => {
            getData(true, false)
          }}
          data={result.data.parts}
        />,
        getContainer: pageDom.current,
      });
    }
  }
  const toSyntheticList = () => {
    const query = [clientId && `clientId=${encodeURIComponent(clientId)}`, openId && `openId=${encodeURIComponent(openId)}`].filter(Boolean).join('&')
    const uri = `/front/activities/fragmentsSyntheticMa/syntheticList${query ? `?${query}` : ''}`
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push("CustomWeb", { uri: `${window.location.origin}${uri}` })
    } else {
      props.history.push(uri)
    }
  }
  const toMyCollection = () => {
    let uri = `${process.env.REACT_APP_NFT_LINK}/myCollection`
    if (isMiniprogram) {
      const collListStr = encodeURIComponent(JSON.stringify(data?.collList || []))
      const query = [
        `collList=${collListStr}`,
        clientId && `clientId=${encodeURIComponent(clientId)}`,
        openId && `openId=${encodeURIComponent(openId)}`
      ].filter(Boolean).join('&')
      uri = `/front/activities/fragmentsSyntheticMa/mycollection?${query}`
    }
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push("CustomWeb", { uri })
    } else {
      props.history.push(uri)
    }
  }
  const handleShareForMini = () => {
    window.JsBridge.miniNavigateTo(`/pages/activitys/fragmentsMaByInvite/share?inviteCode=${clientId}`)
  }
  const toVerifyName = () => {
    window.JsBridge.verifyRealName('合成数字藏品，请提前完成实名认证。').then((res) => {
    });
  }
  const ruleClick = () => {
    RulesModal.open({
      btnStyle: {
        background: 'linear-gradient(99deg, #D4BA77 4%, #FFEAB4 98%)',
        color: '#624C16'
      },
      activityCode: Service.activityCode,
      codeType: "activityRule",
      code: Service.activityCode,
    });
  }
  // 按 partType 分组渲染：1-形象图 2-祝福图
  const imageList = data?.list?.filter(item => String(item.partType) === '1') || [];
  const blessingList = data?.list?.filter(item => String(item.partType) === '2') || [];

  return (
    <div className={Styles.fragmentsHome} ref={pageDom}>
      {!isMiniprogram && <div className={Styles.backBox} onClick={() => window.JsBridge.back()}/>}
      <div className={Styles.bannerBox}>
        <div className={Styles.headImg}>
          <div className={Styles.imgDiv}/>
        </div>
        <div className={Styles.ruleBtn} onClick={ruleClick}>活动规则 &gt;</div>
        {!isMiniprogram && !userInfoVerify?.ID && <div className={Styles.verifyNameBtn} onClick={toVerifyName}>实名认证 &gt;</div>}
      </div>
      <div className={Styles.contentBox}>
        {/* 顶部标题 */}
        <div className={Styles.titleBox}>
          <div className={Styles.leftStars}>
            <img src={smallStar} alt="" className={Styles.smallStar}/>
            <img src={bigStar} alt="" className={Styles.bigStar}/>
          </div>
          <div className={Styles.titleText}>邀好友免费领数藏</div>
          <div className={Styles.rightStars}>
            <img src={bigStar} alt="" className={Styles.bigStar}/>
            <img src={smallStar} alt="" className={Styles.smallStar}/>
          </div>
        </div>

        {/* 形象图部分 */}
        <div className={Styles.fragmentsSection}>
          <div className={Styles.sectionTitle}>形象图</div>
          <div className={Styles.fragmentsImgBox}>
            {imageList.map((item, index) => {
              return (
                <div key={index} className={Styles.fragmentsImg}>
                  <img src={item.imgUrl} alt="" style={{ filter: item?.count > 0 ? '' : 'grayscale(100%)'}}/>
                  <div className={Styles.numTag}>{item?.count || 0}</div>
                </div>
              )
            })}
          </div>
        </div>

        {/* 祝福图部分 */}
        <div className={`${Styles.fragmentsSection} ${Styles.blessingSection}`}>
          <div className={Styles.sectionTitle}>祝福图</div>
          <div className={Styles.fragmentsImgBox}>
            {blessingList.map((item, index) => {
              return (
                <div key={index} className={Styles.fragmentsImg}>
                  <img src={item.imgUrl} alt="" style={{ filter: item?.count > 0 ? '' : 'grayscale(100%)'}}/>
                  <div className={Styles.numTag}>{item?.count || 0}</div>
                </div>
              )
            })}
          </div>
          <div className={Styles.rareStatusText}>
            稀有款已合成{data?.rareCount ?? 0}个,剩余{data?.rareRemain ?? 0}个
          </div>
        </div>

        {/* 按钮区域 */}
        <div className={Styles.buttonsBox}>
          <div className={Styles.topButtons}>
            <button 
              className={Styles.syntheticBtn} 
              onClick={handleSynthetic}
              style={{ backgroundImage: `url(${btnBg})` }}
            >
              限量合成藏品
            </button>
            
            <button 
              disabled={!(data?.drawCount > 0)} 
              className={Styles.drawFragmentsBtn} 
              onClick={handleGetFragments}
              style={{ backgroundImage: `url(${btnBg})` }}
            >
              抽碎片({data?.drawCount || 0})
            </button>
          </div>
          
          
          {isMiniprogram&&<button 
            className={Styles.shareBtnNew} 
            onClick={isMiniprogram ? handleShareForMini : handleShare}
            style={{ backgroundImage: `url(${shareBtn})` }}
          >
            {/* 分享邀新得碎片 */}
          </button>}
          {<div className={Styles.btnMyCollection} onClick={toMyCollection}>我的藏品 &gt;</div>}
        </div>

        
      </div>
      <div className={Styles.contentBox2}>

        {/* 集数藏领新年好礼区域 */}
        <div className={Styles.newYearSection}>
          <div className={Styles.newYearTitleBox}>
            <span className={Styles.starChar}>★★</span>
            <div className={Styles.titleText}>集数藏领新年好礼</div>
            <span className={Styles.starChar}>★★</span>
          </div>
          <div className={Styles.newYearDesc}>集齐全套25个藏品可随机获得1个新年藏品</div>
          <div className={Styles.infoRow}>
            <span className={Styles.expireTime}>验仓时间: 2026.3.2 10:00</span>
            <span className={Styles.holdCount}>持有套数: {data?.fullCount ?? 0}</span>
          </div>
          <div className={Styles.collectiblesBox}>
              <div className={Styles.collectibleImg}>
                <img src={newYearImg33} alt=""/>
              </div>
              <div className={Styles.collectibleImg}>
                <img src={newYearImg44} alt=""/>
              </div>
          </div>
          <div className={Styles.benefitsDivider}>
            <span className={Styles.dividerLine}/>
            <span className={Styles.dividerText}>藏品权益</span>
            <span className={Styles.dividerLine}/>
          </div>
          <div className={Styles.giftBox}>
            <img src={giftIconImg} alt="" className={Styles.giftIcon}/>
            <div className={Styles.giftLabel}>开工大礼包</div>
          </div>
        </div>

      </div>
      {/* {isMiniprogram&&<div className={Styles.contentBox3}>
          <div className={Styles.myCollectiblesSection}>
            <div className={Styles.myCollectiblesTitle}>
              <div className={Styles.titleLeft}>我的藏品</div>
              <div className={Styles.titleRight} onClick={toMyCollection}>查看更多 &gt;</div>
            </div>
            <div className={Styles.myCollectiblesBox}>
              {imageList.slice(0, 4).map((item, index) => {
                return (
                  <div key={index} className={Styles.collectibleImg}>
                    <img src={item.imgUrl} alt=""/>
                  </div>
                )
              })}
            </div>
          </div>
        </div>} */}
      
      
      <OpenAppFooter
        visible={popVisable}
        onClose={() => setPopVisable(false)}
        dowonloadUrl={'https://app.gkewang.com/app'}
      />
    </div>
  )
}
export default Home
